import common from "../../../common";
import TutorialFinger from "../../../reusableModules/TutorialFinger";

export default class cutterSelection extends PIXI.Container {
    constructor() {
        super();
        this._trayContainer = null;
        this._cuttersContainer = null;
        this._trayBk = null;
        this._tutorialFinger = null;
        this._createTutorial = true;

        this._signals = {};
        this._signals.cutterSelected = new P3.utils.MiniSignal();
        this._bindings = {};
    }

    init() {
        this.createTrayWithCutters();
        this.animateTrayIn();
    }

    update() {
        if(this._tutorialFinger){
            if(this._createTutorial)
                this._tutorialFinger.update();
            else
                this._tutorialFinger.visible = false;
        }
    }

    destroy(){
        for (const i in this._bindings) {
            if (this._bindings.hasOwnProperty(i)) {
                const binding = this._bindings[i];
                binding.detach();
            }
        }
        this._bindings = {};
        super.destroy();
    }

    createTrayWithCutters(){
        this._trayContainer = new PIXI.Container();
        this.addChild(this._trayContainer);

        this._trayBk = new PIXI.Sprite(P3.assets.texture('tray'));
        this._trayBk.anchor.set(0.5);
        this._trayBk.scale.set(0.5);
        this._trayContainer.addChild(this._trayBk);
        this._trayContainer.position.set(common.STAGE_WIDTH * 0.5, -this._trayBk.height);

        this._cuttersContainer = new PIXI.Container();
        this._trayContainer.addChild(this._cuttersContainer);

        let trayPositions = [
            {x: this._trayBk.x - 70, y: this._trayBk.y - 70},
            {x: this._trayBk.x + 70, y: this._trayBk.y - 70},

            {x: this._trayBk.x - 140, y: this._trayBk.y + 70},
            {x: this._trayBk.x, y: this._trayBk.y + 70},
            {x: this._trayBk.x + 140, y: this._trayBk.y + 70},
        ];

        for (let shape in common.selectedRecipeBuild.cuttingTools[0].shapes) {
            let states = new P3.ButtonStates();
            states.normal = P3.assets.texture(common.selectedRecipeBuild.cuttingTools[0].shapes[shape]);

            let button = new P3.Button(states);
            button.x = trayPositions[shape].x;
            button.y = trayPositions[shape].y;
            button.scale.set(0.5);
            button.signals.down.add(this.onButtonClick, this);
            button._cookieTexture = P3.assets.texture(common.selectedRecipeBuild.cuttingTools[2].cookieCutouts[shape]);
            button._renderTextureBrush = P3.assets.texture(common.selectedRecipeBuild.cuttingTools[1].renderTexture[shape]);
            this._cuttersContainer.addChild(button);
        }
    }

    animateTrayIn(){
        new P3.utils.TWEEN.Tween(this._trayContainer, this.tweens)
            .to({
                x: common.STAGE_WIDTH * 0.5, y: common.STAGE_HEIGHT * 0.5
            }, 1500)
            .easing(P3.utils.TWEEN.Easing.Quadratic.InOut)
            .onComplete(()=>{
                this.createTutorial();
            })
            .start();
    }

    animateTrayOut(){
        new P3.utils.TWEEN.Tween(this._trayContainer, this.tweens)
            .to({
                x: common.STAGE_WIDTH * 0.5, y: -this._trayBk.height
            }, 1500)
            .easing(P3.utils.TWEEN.Easing.Quadratic.InOut)
            .onStart(()=>{
                if(this._tutorialFinger){
                    this.removeChild(this._tutorialFinger);
                    this._tutorialFinger.destroy();
                    this._tutorialFinger = null;
                }
            })
            .start();
    }

    onButtonClick(button){
        this._bindings.help.detach();
        this._createTutorial = false;
        //console.log("button click");
        P3.audio.playSound("sfx_choose_cutter_00");
        this.animateTrayOut();
        this._signals.cutterSelected.dispatch(button);

        common.cutCookieTextures = {
            maskTexture: button._renderTextureBrush,
            shapeTexture: button._cookieTexture
        };

        let request = common.selectedCharacter.getRequest();
        if (request.type !== "shape") return;

        for (let i = 0; i < request.requestedParts.length; i++) {
            const requestedPart = request.requestedParts[i];
            let cookieTexture = button._cookieTexture.textureCacheIds[0];

            let k = cookieTexture.slice(5);
            let j = k.slice(0, -4);
            let z = requestedPart.slice(5);

            if (j === z) {
                common.selectedCharacter._requestCompleted = true;
                //console.log('Line ' + 312 + ": " + "request completed");
            }
        }
    }

    createTutorial(){
        if(this._tutorialFinger != null){
            this.removeChild(this._tutorialFinger);
            this._tutorialFinger.destroy();
            this._tutorialFinger = null;
        }

        if(!this._createTutorial) return;
        this._tutorialFinger = new TutorialFinger({x:common.STAGE_WIDTH * 0.5, y: common.STAGE_HEIGHT * 0.5 - 35}, 10, -1);
        this.addChild(this._tutorialFinger);
        this._tutorialFinger.clickDown();
        this._tutorialFinger.clickUp();
        this._tutorialFinger.play();
       // console.log('init tutorial');
    }
}